import WithheldDestinationsPage from "/src/features/supervision/withheldDestinations/components/WithheldDestinationsPage";

function WithheldDestinationList() {
    return <WithheldDestinationsPage />;
}

export default WithheldDestinationList;
